export default __webpack_public_path__ + "static/media/plus.bbc0e99c.svg";